import {Basket} from './Basket';
import {DocumentList} from './DocumentList';
import {DocumentFilter} from './DocumentFilter';
import {DocumentPagination} from './DocumentPagination';

export function initDocumentShop() {
  if (document.querySelectorAll('#documentshop')) {
    (new Basket()).initBasket();
    (new DocumentList()).initDocumentList();
    (new DocumentFilter());
    (new DocumentFilter({
      categoryFilterFormId: 'mobile-filter-form',
      filterCategoryGroupInputId: 'modalFilterCategoryGroup',
      filterCategoryInputId: 'modalFilterCategory',
    }));
    (new DocumentPagination());
  }
}
